
export default {
  data: function data() {
    return {
      steps: ['点击「选择文件」or 拖拽文件上传', '勾选需要生成的尺寸', '勾选需要输出的格式', '点击「generate」，下方显示制作进度', '在线制作完成后，自动下载压缩包']
    };
  }
};